export default "__VITE_ASSET__Dp6z4itE__"